module.exports = __webpack_public_path__ + "static/07-81404fdf558fcb82e0345e0958cedee5.png";